import { React, useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import axios from 'axios'
import CompCard from './CompCard'

function CompGames() {
    
    const [ objData, setData    ] = useState();
    const [ error,   setError   ] = useState(null);
    const [ loading, setLoading ] = useState(true);
    const [ total,   setTotal   ] = useState(0);
    const [ page,    setPage    ] = useState(1);
    const [ perPage, setPerPage ] = useState(9);
    const [ totPages,setTotPages] = useState(1);
    const [ query,   setQuery   ] = useState('');

    const { url } = useParams()

    const itemsPerPage = [3, 6, 9, 18, 27, 36, 45, 54, 63, 72, 81, 90, 99, 108]

    const lblTxt = {
      "First": "<<",
      "Previous": "<",
      "Next": ">",
      "Last": ">>"
    }

    useEffect(() => {
      async function getData(url) {
        try {
          //const apiBaseUrl = 'https://ahknet.ddnsfree.com/api01/list/'
          const apiBaseUrl = 'https://ahknet.ddnsfree.com/api01/paginate/'
          //const apiBaseUrl = '/api01/paginate/'
          let strUrl = `${apiBaseUrl}psn_${url}?page=${page}&per_page=${perPage}&filterName=${query}`
          const response = await axios.get(strUrl)
          //console.log(response)
          setData(response.data)
          //setTotal(response.data.data.purchasedTitlesRetrieve.games.length)
          setTotal(response.data.total)
          setTotPages(response.data.total_pages)
          setError(null)
        } catch (err) {
          setError(err.message)
          setData(null)
        } finally {
          setLoading(false);
        }
      }
      getData(url);
      window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
    }, [url, page, perPage, query]);

    function handlePageNav(dir) {
      if (dir === "first") setPage(1)
      if (dir === "last") setPage(totPages)
      if (dir === "previous") {
        if (page > 1 && page <= totPages) setPage( currentPage => currentPage - 1)
      }
      if (dir === "next") {
        if (page < totPages && page > 0) {
          setPage( currentPage => currentPage + 1)
        } else {
          setPage( totPages )
        }
      }
      window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
    }

    function handlePerPage(n) {
      setPerPage(n.target.value)
    }

    function handleSearchBar(e) {
      setQuery(e.target.value)
    }

    function handleCurrPage(e) {
      if (Number(e.target.value) > 0 && Number(e.target.value) <= totPages ) {
        setPage(Number(e.target.value))
      } else {
        setPage(page)
      }
    }
  

    let navbar = (
      <>
      <div className="d-flex p-1 justify-content-around">
        <small className="text-muted">Pages: { totPages }</small>
        <small className="text-muted">Items: { total }</small>
        <div>
          <small className="text-muted align-top">Per page: </small>
          <select className="btn btn-sm btn-outline-secondary" value={ perPage } onChange={ handlePerPage }>
            {itemsPerPage.map((qtd, index) => {
                  return <option value={ qtd } key={"opt_" + index.toString()}>{ qtd }</option>
            })}
          </select>
        </div>
      </div>
      <div className="d-flex p-1 justify-content-around">
        <button className="btn btn-sm btn-outline-secondary" onClick={ () => handlePageNav("first") }>{ lblTxt["First"] }</button>
        <button className="btn btn-sm btn-outline-secondary" onClick={ () => handlePageNav("previous") }>{ lblTxt["Previous"] }</button>
        <div className="col-xs-2">
          <label className="text-muted" for="currPage" id="lblCurrPage">Page:</label>
          <input 
            className="form-control-sm" 
            type="text" 
            id="currPage" 
            name="currPage" 
            value={ page } 
            onChange={ handleCurrPage } 
          />
        </div>
        <button className="btn btn-sm btn-outline-secondary" onClick={ () => handlePageNav("next") }>{ lblTxt["Next"] }</button>
        <button className="btn btn-sm btn-outline-secondary" onClick={ () => handlePageNav("last") }>{ lblTxt["Last"] }</button>
      </div>
      </>
    )
    

    let content = ""

    if ( !loading ) {
      //console.log(objData.data)
      content = (
        <>
        <div className="d-flex p-1 justify-content-around">
          <input className="form-control form-control-sm" type="text" name="searchBox" onChange={ handleSearchBar }></input>
        </div>
        { navbar }
        <div className="row" key="row12345">
            {/*objData.data.purchasedTitlesRetrieve.games.map((game, index) => <CompCard data={game} index={index} />)*/}
            {objData.data.map((game, index) => <CompCard data={game} index={index} key={"card_" + index.toString()} />)}
        </div>
        { navbar }
        </>
      ) 
    }

    if ( loading ) {
      content = (
        <p>Loading...</p>
      )
    }

    if ( error ) {
      content = (
        <p>{error}</p>
      )
    }

    return (
        <div className="album py-5 bg-light">
            <div className="container">
              {content}
            </div>
        </div>
    )
}
export default CompGames